import React from "react";

import {
	IEventPlayer,
	IPlayerStatGroup,
} from "@data-types/sport-stats/SportStatsTypes";
import classNames from "classnames";

import CountryIcon from "@components/icons/CountryIcon";

export function PlayerStatsGroupHeader(props: {
	isExpanded?: boolean;
	onSetExpand: (newValue: boolean) => void;
	player: IEventPlayer;
	statsGroup: IPlayerStatGroup;
}) {
	const { isExpanded, onSetExpand, player } = props;

	const headClass = classNames("statistics--player__header btn btn--reset", {
		"is-collapsed": !isExpanded,
		"is-expanded": isExpanded,
	});

	const toggleIconClass = classNames("u-icon u-icon--xsml", {
		"u-icon--caret--down": !isExpanded,
		"u-icon--caret--up": isExpanded,
	});

	const playerRating = +player.rating.toFixed(1);

	const counterClassName = classNames(
		"statistics--player__tag tag tag--med tag--rating",
		{
			"tag--rating--bottom": playerRating > 0 && playerRating <= 6,
			"tag--rating--low": playerRating > 6 && playerRating <= 6.5,
			"tag--rating--medium": playerRating > 6.5 && playerRating <= 7,
			"tag--rating--good": playerRating > 7 && playerRating <= 8,
			"tag--rating--high": playerRating > 8 && playerRating <= 9,
			"tag--rating--top": playerRating > 9 && playerRating <= 10,
			"tag--rating--none": !player.rating,
		}
	);

	const playerCard = (yellowCard?: number, redCard?: number) => {
		if (yellowCard === 1 && redCard !== 1) {
			return (
				<i className="u-icon u-icon--xsml u-icon--card u-icon--card--rotate u-icon--card--yellow" />
			);
		} else if (redCard === 1 || (yellowCard === 1 && redCard === 1)) {
			return (
				<i className="u-icon u-icon--xsml u-icon--card u-icon--card--rotate u-icon--card--red" />
			);
		} else if (yellowCard === 2) {
			return (
				<i className="u-icon u-icon--xsml u-icon--card u-icon--card--combined" />
			);
		}
	};

	const playerAssists = Number(player.statistics?.summary?.assists ?? 0);

	return (
		<div className={headClass} onClick={() => onSetExpand(!isExpanded)}>
			<div className="statistics--player__jersey">
				<div className="statistics--player__number">
					{player.jerseyNumber}
				</div>
			</div>

			<div className="statistics--player__title">
				<div className="statistics--player__team">
					<div className="statistics--player__position">
						{player.position}
					</div>
					<div
						className="statistics--player__name"
						title={player.name}
					>
						{player.name}
					</div>
					<CountryIcon
						flagCode={player.country}
						className="statistics--player__country u-icon--xsml"
					/>
				</div>

				<div className="statistics--player__info">
					{player.substitute ? (
						<i className="u-icon u-icon--xsml u-icon--substitute" />
					) : null}

					{player.goals > 0 && (
						<div className="statistics--player__goal">
							<i className="u-icon u-icon--xsml u-icon--goal" />
							<span>{player.goals > 1 ? player.goals : ""}</span>
						</div>
					)}

					{playerAssists > 0 && (
						<div className="statistics--player__goal">
							<i className="u-icon u-icon--xsml u-icon--assists" />
							<span>
								{playerAssists > 1 ? playerAssists : ""}
							</span>
						</div>
					)}

					{player.ownGoals > 0 && (
						<div className="statistics--player__goal">
							<i className="u-icon u-icon--xsml u-icon--own-goal" />
							<span>
								{player.ownGoals > 1 ? player.ownGoals : ""}
							</span>
						</div>
					)}

					{playerCard(player.yellowCard, player.redCard)}
				</div>
			</div>

			<span className={counterClassName}>
				{player.rating ? player.rating.toFixed(1) : "-"}
			</span>

			<i className={toggleIconClass} />
		</div>
	);
}
